import http from "../../helpers/axiosClient";

export const getDetailProduct = (param, callback) => {
    http.get("/Products/Product/ApiDetail",{params: param})
        .then(response => {
            if (response.statusCode === 200) {
                callback(response.data);
            } else {
                console.error("ApiDetail:" + response.message)
            }
        })
        .catch(e => {
            console.log(e)
        })

}


let addCartHttp = null;
export const addCart = async (param,callback) => {
    if (addCartHttp == null) {
        addCartHttp = http.post("/Users/Cart/AddCart", param);
    }
    try {
        let response = await addCartHttp;
        callback(response);
        addCartHttp = null;
    }catch (e) {
        console.log(e)
        addCartHttp = null;
    }
}